"use client";
import React, { useEffect } from "react";
import { GroupHeader } from "../../../ui/Headers";
import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";
import { Service } from "../../design1/components/OurServices";
import { Config } from "src/types";
import { newData } from "../../design1/components";
import { EmblaCarouselType } from "embla-carousel";
import { ButtonControls } from "../../design1/components/Announcement";
import { Card2 } from "../ContactUs2";
import { useGroupedServices } from "src/app/hooks/useGroupServices";
const Services = (config: Config) => {
  const services = config.companyServices;
  if (config.companyServices?.length === 0 || services?.[0] === "N/A") {
    return null;
  }
  return (
    <section className="py-14">
      <div className="wrapper">
        <GroupHeader
          max={1000}
          subheader="Discover our comprehensive range of services designed to simplify your real estate journey."
          header="What We Offer"
        />
      </div>

      <OurServices {...config} />
    </section>
  );
};
export default Services;

const OurServices = (config: Config) => {
  return (
    <div className="overflow-hidden wrapper mt-4">
      <SliderParent data={config?.companyServices} />
    </div>
  );
};

const Slider: React.FC<{
  direction: "rtl" | "ltr";
  data: Service[];
  emblaApiRef: (api: EmblaCarouselType) => void;
}> = ({ data, direction, emblaApiRef }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, direction, align: "start" },
    [AutoScroll({ playOnInit: false, speed: 2 })]
  );

  useEffect(() => {
    if (emblaApi) emblaApiRef(emblaApi);
  }, [emblaApi, emblaApiRef]);

  return (
    <div className="relative " ref={emblaRef}>
      <div className={`flex  ${direction === "rtl" && "flex-row-reverse"}`}>
        {data.map((item, index) => (
          <div
            key={index}
            className="transform-none md:!w-[100%] xl:w-[50%] w-[33.3333%]  h-auto shrink-0 pr-8"
          >
            <Card2 headerAs="h3" className="w-full !min-h-[8em]" {...item} />
          </div>
        ))}
      </div>
    </div>
  );
};

export const SliderParent: React.FC<{ data?: string[] }> = ({ data }) => {
  const { slidersData, setEmblaApi, scrollPrev, scrollNext } =
    useGroupedServices(data, newData);
  return (
    <div className="flex relative flex-col gap-14">
      <button
        onClick={scrollPrev}
        className="absolute top-1/2 z-[30] cursor-pointer rotate-[180deg] left-0 transform -translate-y-1/2"
      >
        <ButtonControls />
      </button>
      <button
        onClick={scrollNext}
        className="absolute top-1/2 z-[30] right-0 transform -translate-y-1/2"
      >
        <ButtonControls />
      </button>
      {slidersData.map((sliderData, index) => (
        <Slider
          key={index}
          data={sliderData}
          direction="rtl"
          emblaApiRef={setEmblaApi(index)}
        />
      ))}
    </div>
  );
};
